import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
  margin-bottom: ${sizes.small};
`;

export const FilterTabs = styled.div`
  display: flex;
  gap: ${sizes.xSmall};
`;

export const FilterChip = styled.button<{ active?: boolean }>`
  display: inline-block;
  font-size: ${fontSize.small};
  line-height: 1.8rem;
  border-radius: 2rem;
  padding: 0.3rem ${sizes.small};
  cursor: pointer;
  border: 1px solid ${colors.purple4};
  background-color: ${({ active }) => active ? colors.purple4 : 'transparent'};
  color: ${({ active }) => active ? colors.white : colors.purple5};

  &:hover {
    background-color: ${({ active }) => active ? colors.purple4 : colors.purple2};
  }
`;
